import { Component, inject } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { BirthdayEmailModal } from '../birthday/birthday-email-modal';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'via-email-modal',
  imports: [MatDialogModule, MatIconModule],
  templateUrl: './general-email-modal.html',
  styleUrl: './general-email-modal.scss',
})
export class GeneralEmailModal {
  private readonly dialogRef = inject(MatDialogRef<BirthdayEmailModal>);

  close(): void {
    this.dialogRef.close();
  }
}
